export default __webpack_public_path__ + "static/media/close.9f33748a.svg";